


















































































































































































































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import multipleDataEchart from '../../../components/charts/multipleDataEchart.vue'
import Util from '../../../lib/util'
import {GetRecipeData,Prescribe,DialysOff,GetDialysOff} from '../../../api/dialysisProcess'

import uploadImg from '../../../components/upload/dialysisBeginUploadImg.vue'

import dialysisBeginForm from './dialysisBeginForm'


@Component({
    components:{
        uploadImg
    }
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    form:dialysisBeginForm = new dialysisBeginForm()


    //透析上下机类型
    dialysisType = 1
    async created() {
        console.log(this.form)
        await this.getBeforeDialysOn()
    }
    diyInfo:any = {}
    //加载
    async getBeforeDialysOn(){
        let data = {
            DialysisSignId:this.data.dialysisSignId,
        }
        let res = await GetDialysOff(data)
        this.diyInfo = res.objects
        this.form.recordTime = this.diyInfo.endTime
        this.form.ufv = this.diyInfo.ultrafiltrationVolume
        console.log(this.diyInfo)
    }
    piclist:any = {}
    picConfirm(list:any){
        let paths = list.map((item:any)=>{
            return item.path
        })
        this.form.vaAssest.imagePath = paths.join(',')
    }

    //表单值
    rules = {};

    //上机
    async save(){
        this.form.recipeId = this.data.recipeId
        let data = this.form
        let res = await DialysOff(data)
        if(res.status==1){
            this.$emit('input',false);
            this.$emit('on-back')
        }
    }
   
    mounted() {
        
    }

    
    cancel(){
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/dialysisOff.vue